<template>
	<div class="rounded-sm">
		<div>
			<div class="hidden only:block">
				<slot name="empty" />
			</div>
			<slot />
		</div>
	</div>
</template>
